import { FEATURED_CHALLENGE_EXCERPTS } from '@/constants/homePageData';

export const POST_CATEGORY_RULES = [
  { match: /challenge|sell|sales/i, label: 'Challenge', slug: 'challenge', cta: 'Start challenge' },
  { match: /test|assessment|employability|aptitude|quiz/i, label: 'Assessment', slug: 'assessment', cta: 'Take test' },
  { match: /interview|tips|question/i, label: 'Interview prep', slug: 'interview', cta: 'Attempt now' },
  { match: /skill|learn|course|upskill/i, label: 'Skills', slug: 'skills', cta: 'Attempt now' },
];

export const DEFAULT_POST_CATEGORY = { label: 'Challenge', slug: 'challenge', cta: 'Attempt now' };

export function stripHtml(text) {
  return (text || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function slugify(text) {
  return (text || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
}

export function getPostTitle(post) {
  return post?.title || post?.post_title || post?.name || 'Post';
}

export function getPostCategory(post) {
  const text = getPostTitle(post) + ' ' + stripHtml(
    post?.short_description || post?.description || post?.summary || '',
  );
  return POST_CATEGORY_RULES.find(r => r.match.test(text)) || DEFAULT_POST_CATEGORY;
}

export function getPostCtaLabel(post) {
  if (post?.label) return post.label;
  return getPostCategory(post).cta || DEFAULT_POST_CATEGORY.cta;
}

export function getPostImage(post, s3Base = '') {
  const raw = post?.image_url || post?.banner_url || post?.thumbnail
    || post?.post_image || post?.featured_image || post?.image || '';
  if (!raw) return '';
  if (raw.match(/^https?:\/\//i)) return raw;
  return (s3Base || '') + raw;
}

export function getPostDuration(post) {
  const title = getPostTitle(post);
  const fromTitle = title.match(/(\d+)\s*[- ]?\s*(?:min(?:ute)?s?)/i);
  if (fromTitle) return `${fromTitle[1]} min`;
  const fromDesc = stripHtml(
    post?.short_description || post?.description || post?.summary || '',
  ).match(/(\d+)\s*[- ]?\s*(?:min(?:ute)?s?)/i);
  if (fromDesc) return `${fromDesc[1]} min`;
  return '';
}

export function getPostExcerpt(post, maxLen = 140) {
  const title = getPostTitle(post);
  const mapped = FEATURED_CHALLENGE_EXCERPTS.find(r => r.match.test(title));
  if (mapped) return mapped.excerpt;
  const desc = stripHtml(post?.short_description || post?.description || post?.summary || '');
  if (!desc) return 'Attempt this challenge and see how you score against other candidates.';
  return desc.length > maxLen ? `${desc.slice(0, maxLen)}…` : desc;
}

export function getPostTimestamp(post) {
  return post?.updated_at || post?.updated_time || post?.created_at || null;
}

export function formatPostDate(post) {
  const timestamp = getPostTimestamp(post);
  if (!timestamp) return '';
  const parsedDate = new Date(Number(timestamp) * 1000);
  if (isNaN(parsedDate.getTime())) return timestamp;
  return parsedDate.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function isRecentPost(post) {
  const timestamp = getPostTimestamp(post);
  if (!timestamp) return false;
  const parsedDate = new Date(Number(timestamp) * 1000);
  if (isNaN(parsedDate.getTime())) return false;
  const days = (Date.now() - parsedDate.getTime()) / (1000 * 60 * 60 * 24);
  return days <= 14;
}

export function getPostLink(post) {
  const id = post?.id || post?.post_id;
  const slug = slugify(getPostTitle(post));
  if (!id) return '/posts';
  return `/post/${slug}-${id}`;
}

export function normalizePostLink(link) {
  if (!link) return '';
  if (link.match(/^https?:\/\//i)) return link;
  return `https://${link}`;
}

export function getPostCtaHref(post, isLogin) {
  const link = normalizePostLink(post?.link);
  if (!link) return '';
  if (isLogin || post?.type === 2) return link;
  const redirect = encodeURIComponent(link);
  const src = post?.src || '';
  return `/jobseeker/register?src=${src}&&redirect_from=${redirect}`;
}
